import React, { useEffect } from "react";
import { OwcButton } from "@one/react";
import { ConfirmDialogReason } from "../../../../components/shared/ConfirmDialogReason";
import CreateFieldStyled from "../CreateFieldStyled";

const DeleteEquipmentDialog = ({ open, onCancel, deleteEquipmentAccordion, disableEquipmentAccordion, setDisableEquipmentAccordion}) => {
  useEffect(() => {
    setDisableEquipmentAccordion(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ConfirmDialogReason
      open={open}
      close={onCancel}
      approveText={"Delete"}
      approveColor="primary"
      approveVariant="primary"
      cancelText="Cancel"
      cancelVariant="outlined"
      cancelColor="primary"
      onCancel={onCancel}
      testid={"import-file-dialog"}
      title={"Delete booking restriction"}
      renderActions={({ cancelText, approveText }) => (
        <div style={{ paddingBottom: 8, display: "flex" }}>
          <OwcButton
            data-testid="confirm-dialog-actions-button-cancel"
            onClick={onCancel}
            variant="secondary"
            style={{ marginRight: 32 }}
          >
            {cancelText}
          </OwcButton>
          <OwcButton
            data-testid="confirm-dialog-actions-button-approve"
            onClick={() => {
              deleteEquipmentAccordion();
            }}
            variant="primary"
            disabled={disableEquipmentAccordion}
          >
            {approveText}
          </OwcButton>
        </div>
      )}
    >
      <CreateFieldStyled>Are you sure you want to delete this booking restriction?</CreateFieldStyled>
    </ConfirmDialogReason>
  );
};

export default DeleteEquipmentDialog;
